import {queryTransactionHistoryPageApi} from "@/api/lxh/finance/offline/transactionHistoryApi";
import sd from "silly-datetime";

export const mixins = {
    props:{
        toType:{
            type: String,
            default: null
        }
    },
    components: {},
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            rows: [],
            total: 0,
            searchDataRange: [],
            options: [],
            queryParams: {
                current: 1,
                size: 10,
                isFreeze: "",
                type: "",
                storeId: "",
                startTime: "",
                endTime: "",
                isWithdraw: "",
                orderNo: ""
            }
        }
    },
    methods: {
        async getPage() {
            let params = JSON.parse(JSON.stringify(this.queryParams))
            if (params.type == -1) {
                params.type = ""
                params.isWithdraw = true
            }
            let {data} = await queryTransactionHistoryPageApi(params)
            this.rows = data.rows
            this.total = data.total
        },
        async searchOverview() {
            if (this.searchDataRange && this.searchDataRange.length === 2) {
                this.queryParams.startTime = sd.format(
                    this.searchDataRange[0],
                    "YYYY-MM-DD"
                ) + " 00:00:00";
                this.queryParams.endTime = sd.format(
                    this.searchDataRange[1],
                    "YYYY-MM-DD"
                ) + " 23:59:59";
            } else {
                this.queryParams.startTime = ""
                this.queryParams.endTime = ""
            }
            this.queryParams.current = 1
            await this.getPage()
        },
        async resetSearchOverview() {
            this.queryParams = {
                current: 1,
                size: 10,
                isFreeze: "",
                type: "",
                storeId: "",
                startTime: "",
                endTime: "",
                isWithdraw: "",
                orderNo:""
            }
            this.searchDataRange = []
            await this.getPage()

        },
        gotoOrder(item){
            const routeData = this.$router.resolve('/order?orderNo=' + item.orderNo)
            window.open(routeData.href, '_blank');
        }
    },
    created() {
        this.queryParams.isFreeze = this.$route.query.isFreeze
    },
    mounted() {
        if (this.toType != null && this.toType >= 0){
            this.queryParams.type = this.toType+ ""
        }
        this.getPage()

    }
}
